import vDisplayOptions from "./v-display-options.vue";

export default Vue => {
  Vue.component("v-display-options", vDisplayOptions);
};
